import React, { useEffect, useState } from "react";
import FormInputField from "@/components/lib/from-input-field";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Form } from "@/components/ui/form";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { toast } from "react-hot-toast";
import useAuth from "@/hooks/useAuth";
import { createFloor, updateFloor } from "@/api/table-floor/tableFloor";

const AddEditFloor = ({
	isOpen,
	onClose,
	formType,
	itemsDialog,
	onRefresh
}) => {
	
	
	const [loading, setLoading] = useState(false);
	const { user } = useAuth();
	
	const form = useForm({
		resolver: zodResolver(addNewFloorCardSchema),
		mode: "onChange",
		defaultValues: {
			name: "",
			status: "active",
		},
	});
	useEffect(() => {
		if (formType === "update" && itemsDialog) {
			form.reset({
				name: itemsDialog.name || "",
				status: itemsDialog.status || "active",
			});
		}
		if (formType === "create") {
			form.reset({
				name: "",
				status: "active",
			});
		}
	}, [formType, itemsDialog, form]);

	const { reset } = form;

	const addFloorCardData = async (data) => {
		setLoading(true);

		const payload = {
			...data,
			restaurant_id: user.restaurant_id,
		};
	
		try {
			let res;

			if (formType === "update") {
				res = await updateFloor(itemsDialog.id, payload);
			} else {
				res = await createFloor(payload);
			}

			if (res.status === "success") {
				if (formType === "update") {
					toast.success("Floor Card updated successfully!");
				} else {
					toast.success("Floor Card added successfully!");
				}
				onClose();
				if (onRefresh) onRefresh();
				reset();
			} else {
				toast.error(res.message || "Something went wrong!");
			}
		} catch (err) {
				toast.error(err?.message || "Failed to process Floor Card");
		} finally {
				setLoading(false);
		}
	};
	
	if (!isOpen) return null;

	return (
			<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
				<Card className="bg-cblack4 text-cwhite w-96">
					<CardHeader>
						<CardTitle className=" text-cwhite">
							{formType === "update"
								? "Update Floor"
								: "Add New Floor"}
						</CardTitle>
					</CardHeader>
					<Separator />
					<CardContent>
						<div className="mt-8">
							<Form {...form}>
								<form
									onSubmit={form.handleSubmit(addFloorCardData)}
									className="flex flex-col gap-8"
								>
									<FormInputField
										name="name"
										style="bg-cblack3"
										placeholder={"Enter name"}
										form={form}
										type="text"
										label={"Name"}
										required={true}
									/>

									<FormInputField
										name="status"
										style="bg-cblack3"
										placeholder={"Select status"}
										form={form}
										type="select"
										parseAs="string"
										selectOption={[
											{
												label: "Active",
												value: "active",
											},
											{ label: "Inactive", value: "inactive" },
										]}
										label={"Status"}
										required={true}
									/>

									<div className="mt-4 flex gap-5 w-full">
										{/* <Link className="w-full" to={"/loyalty/gift-card"}> */}
											<Button className="w-full bg-cred text-white" onClick={onClose}>
												Cancel
											</Button>
										{/* </Link> */}

										<Button isLoading={loading} className="w-full bg-cyellow">
											{formType === "update" ? " Update" : " Confirm"}
										</Button>
									</div>
								</form>
							</Form>
						</div>
					</CardContent>
				</Card>
			</div>
	);
};

export default AddEditFloor;

const addNewFloorCardSchema = z.object({
  name: z.string().min(1, "Note is required"),
  status: z.string().min(1, "Status is required"),
});
